<template>
    <app-layout :showTrialPeriodBar="false" :isPageLoading="isPagePreparing">
        <common-page-plain>
            <common-content-spacer height="medium">
                <common-page-header
                    :heading="$t('pages.public.find_provider.heading')"
                    :content="$t('pages.public.find_provider.description')"
                    :isCenter="true"
                ></common-page-header>

                <common-content-wrapper width="small">
                    <referrals-new-search-form
                        :insurancePlans="insurancePlans"
                        :specialities="specialities"
                        :states="states"
                        :facilityServices="facilityServices"
                        @sent="showResults($event)"
                    ></referrals-new-search-form>
                </common-content-wrapper>
            </common-content-spacer>
        </common-page-plain>
    </app-layout>
</template>

<script>
    import ReferralsNewSearchForm from 'components/forms/ReferralsNewSearchForm'
    import SpecialitiesAPI from 'api/SpecialitiesAPI'
    import StatesAPI from 'api/StatesAPI'
    import AppLayout from 'components/layouts/AppLayout'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import GoogleAnalyticsService from 'services/GoogleAnalyticsService'
    import Store from '~/store'

    export default {
        mixins: [PageWithDataMixin],
        components: {
            AppLayout,
            ReferralsNewSearchForm,
        },

        data() {
            return {
                insurancePlans: [],
                specialities: [],
                states: [],
                facilityServices: [],
                isPagePreparing: true,
            }
        },

        methods: {
            showResults(query) {
                localStorage.setItem('findProviderQuery', JSON.stringify(query))
                this.$router.push({
                    name: 'public.find-provider.results',
                    query: query,
                    params: {
                        existingReferral: this.$route.params.existingReferral,
                    },
                })
            },
            getPageData() {
                Promise.all([SpecialitiesAPI.getList(), StatesAPI.getList()])
                    .then(([specialities, states]) => {
                        this.specialities = specialities
                        this.states = states
                    })
                    .finally(() => {
                        this.isPagePreparing = false
                    })
            },
        },

        mounted() {
            this.getPageData()
            GoogleAnalyticsService.loadGoogleAnalytics(process.env.VUE_APP_GOOGLE_ANALYTICS)
            this.insurancePlans = Store.getters['auth/getInsurancePlans']
        },
    }
</script>
